import { render, staticRenderFns } from "./PlotHome.vue?vue&type=template&id=2ce9101a"
import script from "./PlotHome.vue?vue&type=script&lang=js"
export * from "./PlotHome.vue?vue&type=script&lang=js"
import style0 from "./PlotHome.vue?vue&type=style&index=0&id=2ce9101a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce9101a')) {
      api.createRecord('2ce9101a', component.options)
    } else {
      api.reload('2ce9101a', component.options)
    }
    module.hot.accept("./PlotHome.vue?vue&type=template&id=2ce9101a", function () {
      api.rerender('2ce9101a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/plot/PlotHome.vue"
export default component.exports